export default __webpack_public_path__ + "static/media/running-duotone.f5c562f5.svg";